'use client';

import React from 'react';

import Image from 'components/nextjs-fixes/image';

import { styles } from '.';

type TProps = {
  picture: any;

  onClick: () => void;
};

const PictureItem = (props: TProps) => {
  const { picture, onClick } = props;

  return (
    <li className={styles.container}>
      <div className={styles.figure}>
        <Image
          src={picture.asset?.url}
          alt={picture?.alternativeText ?? ''}
          className={styles.image}
          fill
          onClick={() => onClick()}
          // width={picture.width}
          // height={picture.height}
        />
      </div>
    </li>
  );
};

export default PictureItem;
